import { BaseModel, IBaseModel } from "../base.model";


export interface ITemplateMaintenance extends IBaseModel {
  name?:string;
  description?: string;
  type?:string;
  fk_maint_interval_type?:number;
  interval?:number
  alert_pre_delay?:number
  fk_maint_attribute?:number;
  fk_character_problem?: number;
  fk_character_problem_level_2?:number;
}

export class TemplateMaintenanceDto extends BaseModel implements ITemplateMaintenance {
  name?:string;
  description?: string;
  type?:string;
  fk_maint_interval_type?:number;
  interval?:number
  alert_pre_delay?:number
  fk_maint_attribute?:number;
  fk_character_problem?: number;
  fk_character_problem_level_2?:number;

  constructor(opt: ITemplateMaintenance) {
    super(opt);
    this.name = opt.name || null
    this.description = opt.description || null
    this.type = opt.type || null
    this.fk_maint_interval_type = opt.fk_maint_interval_type || null
    this.interval = opt.interval || null
    this.alert_pre_delay = opt.alert_pre_delay || null
    this.fk_maint_attribute = opt.fk_maint_attribute || null
    this.fk_character_problem = opt.fk_maint_attribute || null
    this.fk_character_problem_level_2 = opt.fk_maint_attribute || null

  }
}



// WEBPACK FOOTER //
// ./src/models/maintenance/template-maintenance.model.ts